import { get } from '../api.service';

export interface SalaryRecord {
  id: number,
  clientName: string,
  amount: number,
  salaryType: number,
  invoiceNumber: number,
  createdDate: string,
  holidayPayNo: string,
  invoiceStatus: number,
  salaryStatus: number
}

export interface SalaryParams {
  PageNumber: number;
  PageSize: number;
  searchQuery?: string;
}

export interface SalaryResponse {
  statusCode: number;
  message: string;
  response: SalaryRecord[];
  totalCount?: number;
  numberOfPages?: number;
}

/**
 * Fetches salary records with pagination.
 * Corresponds to: GET /api/Salary?PageSize=10&PageNumber=1
 * @param params - The request parameters containing PageNumber and PageSize.
 * @returns The API response with salary data.
 */
export const fetchSalaries = async (params: SalaryParams): Promise<SalaryResponse> => {
  try {
    const response = await get('/salarynoticev2/salary', {
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
      searchQuery: params.searchQuery
    });
    return response;
  } catch (error) {
    console.error('Error fetching salaries:', error);
    throw error;
  }
};

// Export deduction service
export * from './deduction.service';
